<template>
	<div id="schollopen">
		<changjing :strings="detailscontent"></changjing>

		<div class="b_banxin">

			<div class="v_box">
				
				<div class="v_boxright">

					<div class="v_boxrightbtn">
						<shopbox :shoplist="shoplist2"></shopbox>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import changjing from '@/components/changjing'
	import choice from '@/views/index/indexseemore/choice.vue'
	import choice1 from '@/views/index/indexseemore/choice1.vue'
	import historyshopbox from '@/views/index/indexseemore/historyshopbox.vue'
	import shopbox from '@/views/index/componentsindex/shopbox.vue'
	import qs from "qs";
	export default {
		name: 'schollopen',
		components: {
			changjing,
			choice,
			choice1,
			historyshopbox,
			shopbox
		},
		data() {
			return {
				starval: '', //最低价
				overval: '', //最高价
				placeval: '', //关键
				listactive1: '',
				listactive2: '',
				listactive3: '',
				//banner数据
				bannerlist: [],
				shoplist: [{
					shopimg: require('@/assets/img/img5.png'),
					shopname: ' 晨光ASCN950晨光ASCN9506会议台签（1/10/26会议台签（1/10/200）',
					shopmoney: ' 108',
					shopnum: '1111',
					shopid: ' 108',
				}],
				//一级分类
				objlist1: [],
				objlist2: [], //二级分类
				objlist3: [], //三级分类
				shoplist2: [],
				http: '', //域名拼接
				shopData: {}, //品牌分类接口，
				seachShop: {}, //搜索商品接口,
				xljg: '', //销量价格
				priceQj: {}, //价格区间
				fenleiid: 0, //选中id
				firstindex: 0,
				twoindex: 0,
				threeindex: 0,
				pinpaiList: [], //品牌
				newShop: {}, //热销商品
				detailscontent:''
			}
		},
		created() {
			let that = this;

			if(that.$storage.get('user_data') != null) {
				that.seachShop['userrole'] = that.$storage.get('user_data').rank_id
			} else {
				that.seachShop["userrole"] = 1
			}
			that.http = that.$publicUrl.http1;
			that.seachShop["tag"] = that.$route.query.label
			that.seachShopFn();

		},
		watch: {
			'$route' (to, from) { //监听路由是否变化
				let that = this;

				if(that.$route.query) { //判断id是否有值

					if(that.$storage.get('user_data') != null) {
						that.seachShop['userrole'] = that.$storage.get('user_data').rank_id
					} else {
						that.seachShop["userrole"] = 1
					}
					that.http = that.$publicUrl.http1;
					that.seachShop["tag"] = that.$route.query.label
					that.seachShopFn();

				}
			}
		},
		methods: {
			seachShopFn() {
				let that = this;
				axios({
						method: "post",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
						},
						url: that.$publicUrl.http1 + that.$publicUrl.goodsscenesget,
						data: qs.stringify(that.seachShop)
					})
					.then(function(response) {
						let data = response.data;
						if(data.stateCode == 10000) {
							let arrshop = data.data.goods.data
							console.log(data.data)
							for(let i in arrshop) {
								arrshop[i].shop_price = arrshop[i].skus[0].shop_price
								arrshop[i].sku_id = arrshop[i].skus[0].sku_id;
								arrshop[i].kucun = arrshop[i].kucun = Number(arrshop[i].skus[0].virtual_inventory) + Number(arrshop[i].skus[0].stock) - Number(arrshop[i].skus[0].virtual_occupy);
							}
							that.shoplist2 = arrshop;
							that.detailscontent = that.formatRichText(data.data.content);
							
						

						} else {
							that.$message({
								message: data.msg,
								type: "warning"
							});
						}
					})
					.catch(function(error) {});
			},
			formatRichText(html) {
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"');
				return newContent;
			},
			formatRichText1(html) {
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				// newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"');
				return newContent;
			},
		
		},
	}
</script>
<style scoped>
	#schollopen {
		width: 100%;
		box-sizing: border-box;
	}
	
	.v_box {
		width: 100%;
		min-height: 300px;
		padding: 30px 0;
		box-sizing: border-box;
	}
	
	.v_boxleft {
		width: 180px;
	}
	
	.v_boxlefttop {
		width: 100%;
		height: 50px;
		font-size: 18px;
		text-align: center;
		line-height: 50px;
		background-color: #f6f6f6;
		border: 1px solid #dddddd;
		border-bottom: 0px;
	}
	
	.v_boxleftbtn {
		width: 100%;
		min-height: 300px;
		background-color: #f6f6f6;
		border-top: 1px solid #dddddd;
		box-sizing: border-box;
		padding-top: 10px;
	}
	
	.v_boxright {
		width: 100%;
		min-height: 300px;
		margin-left: 60px;
		border-top: 1px solid #dddddd;
	}
	
	.v_boxrighttop {
		width: 100%;
		background-color: #f6f6f6;
		height: 50px;
		border-left: 1px solid #dddddd;
		border-right: 1px solid #dddddd;
		border-bottom: 1px solid #dddddd;
	}
	
	.v_boxrighttopson {
		box-sizing: border-box;
		padding: 0 15px;
		font-size: 16px;
		height: 50px;
		overflow: hidden;
	}
	
	.v_boxrighttopsonleft {
		height: 50px;
		line-height: 50px;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.v_boxrighttopsonright {
		width: 20px;
		box-sizing: border-box;
		padding: 10px 0;
	}
	
	.v_boxrighttopsonright span {
		width: 15px;
		height: 15px;
		position: relative;
		display: block;
		font-family: element-icons !important;
		overflow: hidden;
	}
	
	.v_top:after {
		content: "\e78f";
		bottom: -10%;
		left: 50%;
		width: 100%;
		height: 100%;
		position: absolute;
		transform: translateX(-50%);
		cursor: pointer;
	}
	
	.v_active {
		/*background: #DC1E33;*/
		color: #DC1E33;
	}
	
	.v_btn:after {
		content: "\e790";
		top: -10%;
		left: 50%;
		width: 100%;
		height: 100%;
		position: absolute;
		transform: translateX(-50%);
		cursor: pointer;
	}
	
	.v_boxr1 {
		padding: 10px 0;
		height: 50px;
		box-sizing: border-box;
	}
	
	.v_boxr1 .input1 {
		width: 73px;
		box-sizing: border-box;
		height: 30px;
		border: 1px solid #dc1e33;
		padding: 0 10px;
		font-size: 16px;
	}
	
	.v_boxr1 .input2 {
		width: 182px;
		box-sizing: border-box;
		height: 30px;
		border: 1px solid #dc1e33;
		padding: 0 10px;
		font-size: 16px;
	}
	
	.v_boxr1 .input3 {
		width: 50px;
		box-sizing: border-box;
		height: 30px;
		padding: 0 10px;
		font-size: 16px;
		background-color: #dc1e33;
		position: relative;
		cursor: pointer;
	}
	
	.input3:before {
		content: "\e778";
		color: #ffffff;
		width: 20px;
		height: 20px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 10;
		font-size: 20px;
	}
	
	.v_boxrightbtn {
		width: 100%;
		min-height: 200px;
		box-sizing: border-box;
		padding-top: 30px;
	}
	
	.choicebox {
		margin-top: 30px;
		width: 100%;
		min-height: 200px;
		/*border-top: 1px solid #dddddd;
		border-left: 1px solid #dddddd;
		border-right: 1px solid #dddddd;*/
	}
</style>